import { render, staticRenderFns } from "./ItemsInbound.vue?vue&type=template&id=5b072b24&scoped=true"
import script from "./ItemsInbound.vue?vue&type=script&lang=js"
export * from "./ItemsInbound.vue?vue&type=script&lang=js"
import style0 from "./ItemsInbound.vue?vue&type=style&index=0&id=5b072b24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b072b24",
  null
  
)

export default component.exports